import FeaturesMenu from "./DesktopNavBar/FeaturesMenu";
import WhoWeAreForMenu from "./DesktopNavBar/WhoWeAreForMenu";
import ResourceMenu from "./DesktopNavBar/ResourcesMenu";
import { NavMenuDropdownProps } from "src/assets/Types/Redesign/PrimaryNavMenuType.type";

export const WhoWeAreForcategoriesList = [
  {
    categoryTitle: "By practice size",
    navLinks: [
      { copy: "Solo practices", page: "", url: "/ehr-for-solo-practice/" },
      { copy: "Group practices", page: "", url: "/features/group-practice/" },
    ],
  },
  {
    categoryTitle: "By specialty",
    navLinks: [
      {
        copy: "Therapists",
        page: "",
        url: "/specialty/ehr-software-for-therapists/",
      },
      {
        copy: "Speech-Language Pathologists",
        page: "",
        url: "/specialty/software-for-speech-language-pathologists/",
      },
      {
        copy: "Occupational Therapists",
        page: "",
        url: "/specialty/software-for-occupational-therapists/",
      },
    ],
  },
  {
    categoryTitle: "",
    navLinks: [
      { copy: "Psychiatrists", page: "", url: "/specialty/psychiatric-emr/" },
      { copy: "All specialties", page: "", url: "/specialty/" },
    ],
  },
];

export const menuItems = [
  {
    component: WhoWeAreForMenu,
    props: {
      title: "Who we’re for",
      copy: "No matter where you are in your private practice journey, we’re here to help with easy-to-use tools.",
      image: "/images/WhoWeAreFor.png",
      imageAltText: "some alt description",
      categoryList: WhoWeAreForcategoriesList,
    },
    width: "122px",
  },
  {
    component: FeaturesMenu,
    props: {
      title: "Features",
      copy: "From admin work to clinical care, our tools simplify every part of practice management.",
      image: "/images/OfficePractitioner.png",
      imageAltText: "Office Practitioner",
      textLinks: [
        {
          linkCopy: "Features overview",
          page: "/features/",
        },
        {
          linkCopy: "Product demo",
          page: "/demo/",
        },
      ],
      categoryList: [
        {
          categoryTitle: "Streamline ADMIN TASKS",
          navLinks: [
            {
              copy: "Scheduling",
              page: "",
              url: "/features/scheduling-calendar/",
            },
            {
              copy: "Billing & payments",
              page: "",
              url: "/features/credit-card-processing/",
            },
            { copy: "Insurance", page: "", url: "/features/insurance/" },
            {
              copy: "Notes & documentation",
              page: "",
              url: "/features/therapy-notes/",
            },
          ],
        },
        {
          categoryTitle: "Optimize client care",
          navLinks: [
            { copy: "Telehealth", page: "", url: "/features/telehealth/" },
            {
              copy: "Client Portal",
              page: "",
              url: "/features/client-portal/",
            },
            {
              copy: "Measurement-based care",
              page: "",
              url: "/features/measurement-based-care/",
            },
            { copy: "ePrescribe", page: "", url: "/features/eprescribe/" },
          ],
        },
        {
          categoryTitle: "Manage & grow your practice",
          navLinks: [
            { copy: "EHR mobile app", page: "", url: "/features/mobile-app/" },
            {
              copy: "Analytics & reports",
              page: "",
              url: "/features/reports/",
            },
            {
              copy: "Online appointment requests",
              page: "",
              url: "/features/online-booking/",
            },
          ],
        },
        {
          categoryTitle: "Privacy & Support",
          navLinks: [
            {
              copy: "HIPAA-compliant security",
              page: "",
              url: "/features/security/",
            },
            { copy: "Support", page: "", url: "/features/support/" },
            {
              copy: "Switching to SimplePractice",
              page: "",
              url: "/features/simplify-switching/",
            },
          ],
        },
      ],
    },
    width: "85px",
  },
  {
    component: ResourceMenu,
    props: {} as NavMenuDropdownProps,
    width: "99px",
  },
];

export const ResourcesMenuCategories = [
  {
    categoryTitle: "For Practitioners",
    navLinks: [
      {
        copy: "Blog",
        page: "",
        url: "/pollen/",
        description: "Find inspiration and insights.",
      },
      {
        copy: "Resource library",
        page: "",
        url: "/resources/",
        description: "Access free worksheets, webinars, and more.",
      },
      {
        copy: "Track Your Hours",
        page: "",
        url: "https://www.trackyourhours.com/",
        description: "Easily track and log training hours for licensure.",
        externalLink: true,
      },
    ],
  },
  {
    categoryTitle: "For CLients",
    navLinks: [
      {
        copy: "Find a therapist",
        page: "",
        url: "https://meetmonarch.com/",
        description: "Connect with the right therapist for you. ",
        externalLink: true,
      },
      {
        copy: "Therapy-seeker resources",
        page: "",
        url: "https://meetmonarch.com/health-resources",
        description: "View useful content, news, and advice.",
        externalLink: true,
      },
    ],
  },
  {
    categoryTitle: "Product support",
    navLinks: [
      {
        copy: "Product tutorials",
        page: "",
        url: "https://support.simplepractice.com/hc/en-us/articles/360058349331-On-demand-Classes-and-Q-As",
        description: "See how to get the most out of SimplePractice.",
        externalLink: true,
      },
      {
        copy: "Help center",
        page: "",
        url: "https://support.simplepractice.com/hc/en-us",
        description: "Get answers and advice from our team.",
        externalLink: true,
      },
      {
        copy: "FAQs",
        page: "",
        url: "/features/faqs/",
        description: "Explore all of our frequently asked questions.",
      },
    ],
  },
];
